module.exports = __webpack_public_path__ + "static/media/shopping.4a858d68.png";